import type { AnalyticsProvider } from '~analytics/types/analyticsProvider';
import type { RuntimeConfig } from 'nuxt/schema';

interface TikTokTrackEvent {
  track: (eventName: string, eventData?: object) => void;
  page: () => void;
}
declare global {
  interface Window {
    ttq: TikTokTrackEvent;
  }
}

interface TikTokPixel {
  proxy: {
    ttq: TikTokTrackEvent;
  };
}

export default class TikTokPixelProvider implements AnalyticsProvider {
  serviceName: string;
  subscribedEvents: string[];
  config: RuntimeConfig;
  tiktokPixel?: TikTokPixel;
  mappedEvents: Record<string, string>

  constructor(
    serviceName: string,
    config: RuntimeConfig,
    subscribedEvents: string[],
  ) {
    this.serviceName = serviceName;
    this.subscribedEvents = subscribedEvents;
    this.config = config;
    this.mappedEvents = {
      PHOENIX_ACCOUNT_REGISTER_COMPLETED: 'CompleteRegistration',
      PHOENIX_LEARN_TOPIC_COMPLETED: 'SubmitApplication',
    };
  }

  async init() {
    if (!this.config.public.tiktokPixelId) {
      console.warn('TikTok Pixel initialized without a Pixel ID');
      return;
    }

    this.tiktokPixel = <TikTokPixel>(<unknown>useScript(
      {
        key: 'tiktok-pixel',
        src: `https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=${this.config.public.tiktokPixelId}`,
      },
      {
        use: () => ({ ttq: window.ttq }),
      },
    ));

    // Initialize page view
    this.tiktokPixel?.proxy.ttq?.page?.();
  }

  track(eventName: string, eventData?: object) {
    const event = this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      ? this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      : eventName;
    this.tiktokPixel?.proxy.ttq?.track?.(event ?? eventName, eventData);
  }

  identify() {
    // noop atm
  }

  reset() {
    // noop atm
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  setUserProperties(properties: Record<string, unknown>) {
    // noop atm
  }

  getSubscribedEvents() {
    return this.subscribedEvents;
  }
}
